import $ from 'jquery'

const $btnToTop = $('#back-to-top')

const backToTop = () => {
  const scrollTrigger = 100
  const scrollTop = $(window).scrollTop();
  if (scrollTop > scrollTrigger) {
    $btnToTop.addClass('show');
  } else {
    $btnToTop.removeClass('show');
  }
}

( () => {
  if( !$btnToTop.length ){ return }
  backToTop()
  $btnToTop.on('click', (e) => {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0
    }, 700);
  });
})()